"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _redux = require("redux");

var _FormReducer = _interopRequireDefault(require("./Form/FormReducer"));

var _QuestionsReducer = _interopRequireDefault(require("./Questions/QuestionsReducer"));

var _SelectedReducer = _interopRequireDefault(require("./SelectedQuestion/SelectedReducer"));

var _default = exports["default"] = (0, _redux.combineReducers)({
  form: _FormReducer["default"],
  questionSet: _QuestionsReducer["default"],
  selectedQuestion: _SelectedReducer["default"]
});